import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import deleteBasket from './deleteBasket';

const useDeleteBasket = (handleAfterSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (advertisement_id: string) => {
      return deleteBasket(advertisement_id);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
      queryClient.invalidateQueries(['get-basket']);
      queryClient.invalidateQueries(['get-basket-count']);
      queryClient.invalidateQueries(['get-cart-detail-list']);
      queryClient.invalidateQueries(['get-subBrand-advertisement-list']);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default useDeleteBasket;
